import { createContext, FunctionComponent, useContext, useState } from 'react';
import { OmitMethods } from '../types';

interface StatsContextI {
	time: number;
	stops: number;
	distance: number;
	setTime: (time: number) => void;
	setStops: (stops: number) => void;
	setDistance: (distance: number) => void;
}

const initialState: OmitMethods<StatsContextI> = {
	time: 0,
	stops: 0,
	distance: 0
};

export const StatsContext = createContext(initialState as StatsContextI);

export const StatsProvider: FunctionComponent = ({ children }) => {
	const [time, setTime] = useState<number>(initialState.time);
	const [stops, setStops] = useState<number>(initialState.stops);
	const [distance, setDistance] = useState<number>(initialState.distance);

	return (
		<StatsContext.Provider value={{ time, setTime, stops, setStops, distance, setDistance }}>
			{children}
		</StatsContext.Provider>
	);
};

export function useStats() {
	return useContext(StatsContext);
}
